import { API_BASE } from "@/lib/utils";

/** Public status page and banner polling interval (10 minutes). */
export const STATUS_POLL_MS = 10 * 60 * 1000;

export const STATUS_LABELS = {
  operational: "Operational",
  degraded: "Degraded",
  partial_outage: "Partial outage",
  major_outage: "Major outage",
};

export const STATUS_COLORS = {
  operational: "#22c55e",
  degraded: "#eab308",
  partial_outage: "#f97316",
  major_outage: "#ef4444",
};

export async function fetchPublicStatus() {
  const res = await fetch(`${API_BASE}/api/public/status`, { cache: "no-store" });
  if (!res.ok) {
    throw new Error(`Status unavailable (${res.status})`);
  }
  return res.json();
}
